import { Link, usePhoneCampaign } from '@hc-frontend/core-ui';

import { UnstyledCallCampaignWrapperProps } from './unstyled-call-campaign-wrapper.types';

export default function UnstyledCallCampaignWrapper({
  id,
  className,
  children,
  ...otherProps
}: UnstyledCallCampaignWrapperProps) {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <>
        <Link
          data-call-call-type={phoneCampaign.callType}
          data-call-placement={phoneCampaign.placement}
          data-call-product={phoneCampaign.subProduct || phoneCampaign.product}
          data-call-phone={phoneCampaign.href}
          data-call-advertiser={phoneCampaign.advertiser}
          {...otherProps}
          className={className}
          href={phoneCampaign.href}
          id={id}
        >
          {children}
        </Link>
      </>
    );
  }
  return null;
}
